import { Link } from 'react-router-dom';
import { Users, Trophy, Gamepad2, ArrowRight, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export function JoinCommunityCTA() {
  const features = [
    { icon: Gamepad2, label: 'Compete in Tournaments', color: 'text-primary' },
    { icon: Trophy, label: 'Win Championships', color: 'text-gold' },
    { icon: Users, label: 'Join the Community', color: 'text-secondary' },
  ];

  return (
    <section className="py-12">
      <div className="container">
        <Card className="relative overflow-hidden border-primary/20 bg-gradient-to-br from-primary/5 via-background to-secondary/5">
          {/* Background decorations */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-secondary/5 rounded-full blur-3xl"></div>
          
          <CardContent className="relative p-8 md:p-12">
            <div className="text-center max-w-2xl mx-auto">
              {/* Badge */}
              <div className="inline-flex items-center gap-2 rounded-full border border-primary/40 bg-primary/10 px-4 py-1.5 mb-6">
                <Sparkles className="h-4 w-4 text-primary" />
                <span className="text-xs font-semibold text-primary uppercase tracking-wider">
                  Join Viper Strike United Today
                </span>
              </div>

              <h2 className="font-display text-3xl md:text-4xl text-foreground mb-4">
                Ready to Compete?
              </h2>
              
              <p className="text-muted-foreground mb-8 text-lg">
                Join Bangladesh's premier eFootball community and prove your skills against the best players.
              </p>

              {/* Features */}
              <div className="flex flex-wrap items-center justify-center gap-6 mb-8">
                {features.map((feature, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <feature.icon className={`h-5 w-5 ${feature.color}`} />
                    <span className="text-sm text-muted-foreground">{feature.label}</span>
                  </div>
                ))}
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-wrap items-center justify-center gap-4">
                <Button asChild size="lg" className="btn-gaming text-primary-foreground">
                  <Link to="/auth">
                    Get Started
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Link>
                </Button>
                <Button asChild variant="outline" size="lg" className="border-border/50 hover:border-primary/50">
                  <Link to="/tournaments">
                    <Trophy className="mr-2 h-4 w-4 text-gold" />
                    Browse Tournaments
                  </Link>
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
}
